import { TagGroupSchema } from "@redotech/redo-model/support/tag-group-zod-schema";
import * as z from "zod/v4";

export const getTagGroups = {
  name: "getTagGroups" as const,
  input: z.object({}),
  output: z.object({ tagGroups: z.array(TagGroupSchema) }),
};
